import api from '../library/axios';
// import config from '../config';

export default {
  platformBillingHistories({ query = {} }) {
    return api({
      url: '/api/platform-billings',
      params: query,
    });
  },
  platformBillingGenerateVa({ workspace_id, payment_method_id, invoice_id }) {
    return api({
      url: `/api/platform-billings/${workspace_id}/generate_payment`,
      method: 'post',
      data: {
        payment_method_id, invoice_id,
      },
    });
  },
  platformBillingSendEmail({ workspace_id, payment_method_id, invoice_id }) {
    return api({
      url: `/api/platform-billings/${workspace_id}/send_email`,
      method: 'post',
      data: {
        payment_method_id, invoice_id,
      },
    });
  },
  downloadInvoicePlatform({ id, workspace_id }) {
    return api({
      url: `/api/platform-billings/${workspace_id}/${id}/invoice`,
    });
  },
  payWithBalance({ workspace_id, company_id, invoice_id }) {
    return api({
      url: `/api/platform-billings/${workspace_id}/pay_with_balance`,
      method: 'post',
      data: {
        company_id, invoice_id,
      },
    });
  },
  updatePayment({
    workspace_id, company_id, invoice_id, paid_at, status_billing,
  }) {
    return api({
      url: `/api/platform-billings/${workspace_id}/change_payment`,
      method: 'post',
      data: {
        company_id, invoice_id, paid_at, status_billing,
      },
    });
  },
};
